module.exports = __webpack_public_path__ + "img/zombie.bf290e4b.png";